// Centralized route configuration
export const ROUTES = {
  VIEW: '/',
  EDIT: '/spg-edit',
  PUBLISH: '/spg-publish',
  SUBSCRIPTION: '/spg-subscription',
  PAGES: '/spg-pages',
  NOT_FOUND: '/spg-notfound',
}; 